import React from "react";
import { BarChart, Bar, Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, Label } from "recharts";

export const DoubleBarCharts = (props) => {
  const renderCustomRateLabel = (props) => {
    const { x, y, width, value } = props;
    return (
      <text x={x + width / 2} y={y} fill="#000" textAnchor="middle" dy={-2}>
        {`${value}%`}
      </text>
    );
  };
  const renderCustomAdLabel = (props) => {
    const { x, y, width, value } = props;
    return (
      <text x={x + width / 2} y={y} fill="#000" textAnchor="middle" dy={-2}>
        {value}
      </text>
    );
  };
  return (
    <ResponsiveContainer height={props.height ? props.height : 450} width="100%">
      <BarChart
        data={props?.data}
        barSize={50}
        margin={{
          top: 20,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="companyname" />
        <YAxis />
        <Tooltip cursor={{ fill: "transparent" }} />
        <Legend
          verticalAlign="top"
          height={36}
          content={(props) => {
            return (
              <ul className="d-flex justify-content-center">
                {props.payload.map((entry, index) => (
                  <li key={`item-${index}`} className="ms-5 d-flex align-items-center">
                    <div
                      style={{ width: "15px", height: "15px", backgroundColor: `${entry.color}`, marginRight: "5px" }}
                    ></div>
                    {entry.value === "numberofclicks" && "Views Per Ad"}
                    {entry.value === "conversionrate" && "Conversion rate"}
                  </li>
                ))}
              </ul>
            );
          }}
        />
        <Bar dataKey="numberofclicks" fill="#10439F" label={renderCustomAdLabel} />
        <Bar dataKey="conversionrate" fill="#EB8153" label={renderCustomRateLabel} />
      </BarChart>
    </ResponsiveContainer>
  );
};
